<!-- <div class="m-16" @fadeIn> -->
<!--   As a result of AA changing hotel providers, APA currently does not have access -->
<!--   to hotel assignment information. -->
<!--   <a -->
<!--     href="https://alliedpilots.org/tools/hotels" -->
<!--     class="link mt-16" -->
<!--     target="_blank" -->
<!--   > -->
<!--     APA Hotel Webpages -->
<!--   </a> -->
<!-- </div> -->

<ng-container *ngIf="reservation$ | async as reservation">
  <ng-container *ngIf="reservation.isLoading || reservation.response">
    <app-data-box headerTitle="Hotel" class="mt-24">
      <div class="data-box-content">
        <div class="hotel-name-address">
          <div *ngIf="reservation.response" class="hotel-name" @fadeIn>
            {{ reservation.response.hotel.hotelName | titlecase }}
          </div>
          <app-skeleton
            *ngIf="reservation.isLoading && !reservation.response"
            width="14rem"
            height="1.25rem"
            bottomMargin=".2rem"
          ></app-skeleton>
          <div *ngIf="reservation.response" class="address" @fadeIn>
            {{ reservation.response.hotel.address1 }}
          </div>
          <app-skeleton
            *ngIf="reservation.isLoading && !reservation.response"
            width="9rem"
            height=".9rem"
            bottomMargin=".1rem"
          ></app-skeleton>
        </div>
        <mat-divider></mat-divider>
        <div class="hotel-buttons">
          <div class="width-100 flex-center">
            <a
              mat-icon-button
              color="primary"
              [href]="'tel:' + reservation?.response?.hotel?.phone"
              [class.disabled]="!reservation.response?.hotel?.phone"
            >
              <mat-icon>phonelink_ring</mat-icon>
            </a>
          </div>
          <div
            class="width-100 left-divider-1 flex-center img-link"
            *ngIf="theme$ | async as theme"
          >
            <a
              [href]="getAPAHotelWebpageUrl(reservation?.response?.hotel)"
              target="_blank"
              [class.disabled]="!reservation?.response?.hotel"
            >
              <img
                *ngIf="theme === 'dark'"
                src="assets/APA_Logo_Dark.svg"
                width="32"
                height="32"
              />
              <img
                *ngIf="theme !== 'dark'"
                src="assets/APA_Logo.svg"
                width="32"
                height="32"
              />
            </a>
          </div>
          <div class="width-100 left-divider-1 flex-center img-link">
            <a
              [href]="getGoogleMapsLink(reservation?.response?.hotel)"
              target="_blank"
              [class.disabled]="!reservation?.response?.hotel"
            >
              <img
                src="assets/google-maps-2020-icon.svg"
                width="32"
                height="32"
              />
            </a>
          </div>
        </div>
      </div>
    </app-data-box>

    <app-data-box headerTitle="Transportation" class="mt-32">
      <div class="data-box-content">
        <!-- Loading -->
        <div
          *ngIf="reservation.isLoading && !reservation.response"
          class="transport-container"
        >
          <app-skeleton width="12rem" height="1.25rem"></app-skeleton>
          <a
            mat-icon-button
            color="primary"
            class="mod-button"
            [href]=""
            [disabled]="true"
          >
            <mat-icon>phonelink_ring</mat-icon>
          </a>
        </div>
        <!-- Transportation data present (not hotel shuttle) -->
        <div
          *ngIf="reservation.response?.transportation?.phone"
          class="transport-container"
        >
          <div
            *ngIf="reservation.response?.transportation"
            class="transportation-name"
          >
            {{ reservation.response?.transportation?.providerName }}
          </div>
          <a
            mat-icon-button
            color="primary"
            class="mod-button"
            [href]="'tel:' + reservation.response?.transportation?.phone"
            [disabled]="!reservation.response?.transportation?.phone"
          >
            <mat-icon>phonelink_ring</mat-icon>
          </a>
        </div>
        <!-- Reservation but no transportation info indicates hotel shuttle. -->
        <div
          *ngIf="
            reservation.response?.hotel &&
            !reservation.response?.transportation?.phone
          "
          class="transport-container"
        >
          <div class="transportation-name">Hotel Shuttle</div>
          <a
            mat-icon-button
            color="primary"
            [href]="'tel:' + reservation.response?.hotel?.phone"
            [disabled]="!reservation.response?.hotel?.phone"
          >
            <mat-icon>phonelink_ring</mat-icon>
          </a>
        </div>

        <mat-divider></mat-divider>

        <div class="label-3 pickup-location">Pickup Location</div>
        <ng-container *ngIf="reservation.response">
          <div *ngIf="!reservation.response.hotel?.pickupLocation">
            Information unavailable, check CCI.
          </div>
          <div
            *ngIf="reservation.response.hotel?.pickupLocation"
            [innerHTML]="reservation.response.hotel.pickupLocation"
            class="text-sm"
            @fadeIn
          ></div>
        </ng-container>
        <app-skeleton
          *ngIf="reservation.isLoading && !reservation.response"
          width="10rem"
          height=".9rem"
          topMargin=".2rem"
        ></app-skeleton>
      </div>
    </app-data-box>
    <div class="data-status">
      <app-data-status
        [isLoading]="reservation.isLoading"
        [timestamp]="reservation.response?.timestamp"
        (refresh)="onRefreshClick()"
      ></app-data-status>
    </div>
  </ng-container>
  <div
    *ngIf="!reservation.isLoading && !reservation.response"
    class="m-16 text-center text-sm"
    @fadeIn
  >
    <p>Hotel information unavailable</p>
    <p>
      Note: Currently only hotel information assigned to your employee number is
      available.
    </p>
  </div>

  <mat-progress-bar
    *ngIf="reservation.isLoading"
    class="progress-bar-bottom"
    color="accent"
    mode="indeterminate"
  ></mat-progress-bar>
</ng-container>
